export default __webpack_public_path__ + "static/media/330_dummy2016-ferienwohnung01-mobile-de.b9cf1585.png";